import React from 'react';
import { SystemConfiguration } from '../components';

export default () => {
    return (
        <SystemConfiguration.Home />
    )
}